import { render, staticRenderFns } from "./routes-nav-config.vue?vue&type=template&id=5d7687e5&"
import script from "./routes-nav-config.vue?vue&type=script&lang=ts&"
export * from "./routes-nav-config.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports